<script setup lang="ts">
import type { Schemas } from "#shopware";
import {
  getProductName,
  getSmallestThumbnailUrl,
} from "@shopware/helpers";

const props = defineProps<{ product: Schemas["Product"] }>();

const { unitPrice, isListPrice, price } = useProductPrice(toRef(props.product));

const displayFromVariants: ComputedRef<number | undefined> = computed(
  () => props.product?.calculatedCheapestPrice?.unitPrice
);
</script>

<template>
  <div class="flex p-2 gap-4 items-center w-full justify-between">
    <img
      class="w-16 h-16 object-contain shadow-md shrink-0 rounded-md"
      :src="
        getSmallestThumbnailUrl(product.cover?.media) || '/img/placeholder.png'
      "
      :alt="product.name"
    />

    <div class="flex-1 flex flex-col gap-2">
      <h5 class="font-medium line-clamp-2">
        {{ getProductName({ product }) }}
      </h5>

      <div v-if="product.manufacturer?.name" class="flex items-center gap-2">
        <i class="pi pi-tag text-sm"></i>
        <span>{{ product.manufacturer?.name }}</span>
      </div>
    </div>

    <div v-if="unitPrice || isListPrice" class="grid gap-1">
      <SharedPrice
        v-if="unitPrice"
        :class="{ 'text-rose-700': isListPrice }"
        :price="unitPrice"
      />

      <SharedPrice
        v-else
        :class="{ 'text-rose-700': isListPrice }"
        :price="displayFromVariants"
      />

      <SharedPrice
        v-if="isListPrice"
        class="text-gray-500 line-through text-xs"
        :price="price?.listPrice?.price"
      />
    </div>
  </div>
</template>
